/**
 * PriorityChip — My Notes rebuild, Stage 6.
 *
 * Critical (red) / Important (orange) / General (neutral) — the "how
 * crucial this is to address" tag on a note. Shared between NotesPage.jsx's
 * list rows and NoteDetail.jsx's header so the two pages can't quietly
 * drift onto different colours for the same word.
 */

import { V2, solidChip } from './JaiV2'

const PRIORITY_META = {
  critical: { label: 'Critical', color: V2.error },
  important: { label: 'Important', color: V2.warning },
  general: { label: 'General', color: V2.faint },
}

export default function PriorityChip({ priority, size = 'sm' }) {
  const meta = PRIORITY_META[priority] || PRIORITY_META.general
  return (
    <span style={{
      fontSize: size === 'lg' ? 12.5 : 10.5, fontWeight: 800, ...solidChip(meta.color),
      borderRadius: 999,
      padding: size === 'lg' ? '4px 12px' : '2px 8px', letterSpacing: '0.04em',
      textTransform: 'uppercase', whiteSpace: 'nowrap',
    }}>
      {meta.label}
    </span>
  )
}
